import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';

import ProductCarousel from "../Product/productCarousel";

// Import components
import HomeHead from './components/HomeHead';
import Loader from './components/Loader';
import BldcTechnology from './components/BldcTechnology';
import EfficiencyProgress from './components/EfficiencyProgress';
import ProductShowcase from './components/ProductShowcase';
import RemoteFeatures from './components/RemoteFeatures';
import ScrollingGallery from './components/ScrollingGallery';
import VideoSection from './components/VideoSection';
import "./Home.css";

function Home() {
    const [webImage, setWebImage] = useState([]);
    const [mobImage, setMobImage] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [isH3Visible, setIsH3Visible] = useState(false);
    
    const intervalRef = useRef(null);
    const nextSlideButtonRef = useRef(null);
    const h3RefHome = useRef(null);
    const h3Ref1Home = useRef(null);
    const h3Ref2Home = useRef(null);

    // Memoize the video URLs to prevent unnecessary re-renders
    const videoUrls = useMemo(() => [
        "https://youtu.be/Gc24E6TUR7M?si=vWF8civkpoeU9aGx",
        "https://youtu.be/NpfTefrQiYc?si=CCtAtVVHZBfbaZCu",
        "https://youtu.be/UGeb-Q86Ofk?si=AZo0eJ8JemJPntxO",
        "https://youtu.be/UTr94aIgwjY?si=ox-U6B6EOcHgyPwb",
    ], []);

    // Use useCallback for functions to prevent unnecessary re-renders
    const fetchWebData = useCallback(async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotCMSProductCategory/home001`);
            if (response.ok) {
                const result = await response.json();
                
                const webImage = result.data.banners.filter((item) => !item.imgSrc.includes("mob"));
                const mobImage = result.data.banners.filter((item) => item.imgSrc.includes("mob"));
                setWebImage(webImage);
                setMobImage(mobImage);
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0, {
            behavior: 'smooth'
        });
        fetchWebData();
    }, [fetchWebData]);

    useEffect(() => {
        document.title = "Colorbot"; // Set the title when component mounts
        return () => {
            document.title = "Colorbot"; // Reset the title when component unmounts
        };
    }, []);

    // LOADER CODE
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoader(false);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!showLoader) {
            intervalRef.current = setInterval(() => {
                if (!document.getElementById("collapsibleNavbar").classList.contains("show") && !document.getElementById("sidePanel").classList.contains("open")) {
                    if (nextSlideButtonRef.current) {
                        nextSlideButtonRef.current.click();
                    }
                }
            }, 5000);
        }

        return () => clearInterval(intervalRef.current);
    }, [showLoader]);

    // Use useCallback for the scroll handler to prevent unnecessary re-renders
    const handleScroll = useCallback(() => {
        // Check for h3 visibility
        const h3Position = h3RefHome?.current?.offsetTop;
        const offset = window.innerHeight / 2;

        if (scrollPosition + offset >= h3Position) {
            setIsH3Visible(true);
        }
        
        // Handle h3Ref1Home animation
        const title2 = h3Ref1Home.current;
        if (title2) {
            const rect2 = title2.getBoundingClientRect();
            const offset2 = window.innerHeight / 2;

            if (rect2.top <= offset2) {
                title2.classList.add('active');
            }
        }
        
        // Handle h3Ref2Home animation
        const title3 = h3Ref2Home.current;
        if (title3) {
            const rect3 = title3.getBoundingClientRect();
            const offset3 = window.innerHeight / 2;

            if (rect3.top <= offset3) {
                title3.classList.add('active');
            }
        }
        
        setScrollPosition(window.scrollY);
    }, [scrollPosition]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    // Memoize the carousel component to prevent unnecessary re-renders
    const carouselComponent = useMemo(() => {
        return webImage.length > 0 && mobImage.length > 0 ? 
            <ProductCarousel webImages={webImage} mobImages={mobImage} /> 
        : "";
    }, [webImage, mobImage]);

    return (
        showLoader ? 
            <Loader /> 
        : 
            <section className="mt-5 pt-4">
                <HomeHead />
                
                {carouselComponent}
                
                <BldcTechnology />
                
                <EfficiencyProgress />
                
                <ProductShowcase h3RefHome={h3RefHome} isH3Visible={isH3Visible} />
                
                <br />
                
                <RemoteFeatures />
                
                <ScrollingGallery showLoader={showLoader} />
                
                <VideoSection h3Ref2Home={h3Ref2Home} videoUrls={videoUrls} />
            </section>
    );
}

export default React.memo(Home);
